import { render, staticRenderFns } from "./CompanyDeliveryInfo.vue?vue&type=template&id=77497875&"
import script from "./CompanyDeliveryInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyDeliveryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports